<template>
  <div class="app-substitute-sim-wrapper">
    <SimonModal
      :is-visible="showModal"
      id="substitute-sim-modal"
      @hide="showModal = false"
    >
      <template v-slot:modalTitle>
        <slot :name="'header' + typeSlotname + 'Modal'"></slot>
      </template>
      <slot :name="'content' + typeSlotname + 'Modal'"></slot>
    </SimonModal>
    <slot name="cardImg"></slot>
    <slot :name="typeSlotname + 'Header'"></slot>
    <div class="card-copytext">
      <slot :name="typeSlotname + 'Msg'"></slot>
    </div>
    <div class="action-area">
      <button class="text" @click="openInfoModal">
        <slot name="more"></slot>
      </button>
      <span class="eSimNotInstalledTxt" v-if="isEsimNotInstalled"><slot name="eSimNotInstalled"></slot>
      </span>
      <OrderBtn v-if="!showActivationBtn" :order-target-url="orderTargetUrl" :sim-order-status="simOrderStatus"
                :pre-order="setOrderData" :disabled="simOrderStatus.orderable === false || isEsimNotInstalled">
        <template v-for="slot in possibleChildSlotsFor('Order')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </OrderBtn>
      <ActivateBtn v-if="showActivationBtn" @show-success="openActivationSuccess" :disabled="simOrderStatus.activatable === false">
        <template v-for="slot in possibleChildSlotsFor('Activate')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </ActivateBtn>
    </div>
  </div>
</template>

<script>
import transaction from '@/mixins/transaction'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import beErrors from '@/mixins/beErrors'
import ActivateBtn from '@/components/process/generic/SubstituteSimCard/ActivateBtn.vue'
import OrderBtn from '@/components/process/generic/SubstituteSimCard/OrderBtn.vue'
import SimonModal from '@/components/modal/SimonModal.vue'

export default {
  name: 'SubstituteSimCardWrapper',
  components: {
    SimonModal,
    ActivateBtn,
    OrderBtn
  },
  data () {
    return {
      showModal: false
    }
  },
  props: {
    orderTargetUrl: {
      type: String,
      default: ''
    },
    simOrderStatus: {
      type: Object,
      default: () => {}
    }
  },
  mounted () {
    if (this.wasSuccess) {
      this.openOrderSuccess()
      this.setOrderStatus(false)
    }
  },
  methods: {
    ...mapMutations('substituteSimCard', [
      'setOrderStatus'
    ]),
    ...mapActions('substituteSimCard', [
      'resetSimDefaultState'
    ]),
    openInfoModal: function () {
      this.showModal = true
    },
    openOrderSuccess: function () {
      const msg = this.$slots.txtOrderToastSuccess ? this.$slots.txtOrderToastSuccess[0].text : 'SuccessMsg'
      this.successToast(msg)
    },
    openActivationSuccess: function () {
      const msg = this.$slots.txtActivationToastSuccess ? this.$slots.txtActivationToastSuccess[0].text : 'SuccessMsg'
      this.successToast(msg)
    },
    setOrderData: function () {
      this.resetSimDefaultState()
    }
  },
  computed: {
    ...mapGetters('substituteSimCard', [
      'wasSuccess',
      'eSimInstalled',
      'simCardType'
    ]),
    isEsimNotInstalled () {
      return !this.eSimInstalled && this.simCardType === 'E_SIM'
    },
    showActivationBtn: function () {
      return (this.simOrderStatus.activatable && this.simOrderStatus?.type !== 'E_SIM') || (this.simOrderStatus?.orderable === false && this.simOrderStatus?.orderDate != null && this.simOrderStatus?.type !== 'E_SIM')
    },
    typeSlotname: function () {
      if (this.simOrderStatus?.type === 'E_SIM') {
        return 'orderESim'
      } else if (this.simOrderStatus?.type === 'SIM_CARD' && this.simOrderStatus?.orderDate !== null) {
        return 'pending'
      } else if (this.simOrderStatus?.type === 'SIM_CARD' && this.simOrderStatus?.activatable === true) {
        return 'activation'
      } else if (this.simOrderStatus?.type === 'SIM_CARD') {
        return 'orderSimCard'
      } else {
        return 'order'
      }
    }
  },
  mixins: [
    transaction('substituteSim'),
    beErrors
  ]
}
</script>
